import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Seo from "./components/Seo";
import LandingPage from "./pages/LandingPage";
import HoeHetWerktPage from "./pages/HoeHetWerktPage";
import ProductenPage from "./pages/ProductenPage";
import PakkettenPage from "./pages/PakkettenPage";
import VerlanglijstPage from "./pages/VerlanglijstPage";
import FamilieplanPage from "./pages/FamilieplanPage";
import MomentenPage from "./pages/MomentenPage";
import WaaromPage from "./pages/WaaromPage";
import EuropaPage from "./pages/EuropaPage";
import ZakelijkPage from "./pages/ZakelijkPage";
import CadeaubonPage from "./pages/CadeaubonPage";
import AppPage from "./pages/AppPage";
import FaqPage from "./pages/FaqPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import DeleteAccountPage from "./pages/DeleteAccountPage";
import ChangePasswordPage from "./pages/ChangePasswordPage";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Seo />
      <Switch>
        <Route path="/hoe-het-werkt" component={HoeHetWerktPage} />
        <Route path="/producten" component={ProductenPage} />
        <Route path="/pakketten" component={PakkettenPage} />
        <Route path="/verlanglijst" component={VerlanglijstPage} />
        <Route path="/familieplan" component={FamilieplanPage} />
        <Route path="/momenten" component={MomentenPage} />
        <Route path="/waarom" component={WaaromPage} />
        <Route path="/europa" component={EuropaPage} />
        <Route path="/zakelijk" component={ZakelijkPage} />
        <Route path="/cadeaubon" component={CadeaubonPage} />
        <Route path="/app" component={AppPage} />
        <Route path="/faq" component={FaqPage} />
        <Route path="/contact" component={ContactPage} />
        <Route path="/terms" component={TermsPage} />
        <Route path="/privacy" component={PrivacyPage} />
        <Route path="/delete-account" component={DeleteAccountPage} />
        <Route
          path="/change-password/:token"
          component={ChangePasswordPage}
        />
        <Route path="/change-password" component={ChangePasswordPage} />
        <Route path="/" exact component={LandingPage} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
